exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-content[data-v-f2ff4d2a]{max-height:100%}.modal-content .modal-body[data-v-f2ff4d2a]{overflow:auto;min-height:100%;max-height:100%}.modal-content .modal-body .content[data-v-f2ff4d2a]{overflow-y:auto;min-height:100%}.modal-content .modal-body .content .obsolete[data-v-f2ff4d2a]{text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2ff4d2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/stiemert/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/dialogs/modalVariant.vue
// module id = 1331
// module chunks = 147